import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'
import { listWaitingState } from '../recoil/state/page'

import {
  Title,
  TITLE_VARIANT_L,
  Flex,
  Grid,
  GRID_VARIANT_COLLAPSED,
  GridCell,
  Divider
} from 'mailup-web-components'

import IconCell from '../components/Table/IconCell'
import MessageCell from '../components/Table/MessageCell'
import ListCell from '../components/Table/ListCell'
import RecipientsCell from '../components/Table/RecipientsCell'
import ActionsCell from '../components/Table/ActionsCell'
import Head from '../components/Table/Head'
import StatusCell from '../components/Table/StatusCell'
import styled from '@emotion/styled'

const StyledGrid = styled(Grid)`
  border-left: 1px solid #d5dadf;
  border-right: 1px solid #d5dadf;
  background-color: white;
`

export const ListWaiting = () => {
  const intl = useIntl()
  const { Items: items } = useRecoilValue(listWaitingState)

  if (items.length <= 0) return null

  return (
    <>
      <section data-mu-test='b-sendstatus-list--waiting'>
        <Flex justifyContent='center' margin='0 0 16px  0'>
          <Title variant={TITLE_VARIANT_L}>
            {intl.formatMessage({ id: 'Load.Schedulation.StandByTitle' })}
          </Title>
        </Flex>

        <Head lastColumnStringId={'Load.Schedulation.TableStatus'} />
        {items.map((item, i) => (
          <>
            <StyledGrid
              variant={GRID_VARIANT_COLLAPSED}
              data-mu-test='waiting__results-table__row'
              key={`list-sending-item-${i}-${item.idSending}`}
            >
              <GridCell span={1}>
                <IconCell {...item} />
              </GridCell>
              <GridCell span={4}>
                <MessageCell {...item} />
              </GridCell>
              <GridCell span={1}>
                <ListCell {...item} />
              </GridCell>
              <GridCell span={2}>
                <RecipientsCell {...item} />
              </GridCell>
              <GridCell span={3}>
                <StatusCell {...item} />
              </GridCell>
              <GridCell span={1}>
                <ActionsCell {...item} origin='list-waiting' />
              </GridCell>
            </StyledGrid>
            <Divider />
          </>
        ))}
      </section>
    </>
  )
}
